var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgJmLogoBlack(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 500,
    zoomAndPan: "magnify",
    viewBox: "0 0 375 374.999991",
    height: 500,
    preserveAspectRatio: "xMidYMid meet",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "d36d8e47fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.683594 0 L 374 0 L 374 375 L 0.683594 375 Z M 0.683594 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "daf87ab138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.183594 0 C 84.628906 0 0.683594 83.945312 0.683594 187.5 C 0.683594 291.054688 84.628906 375 188.183594 375 C 291.738281 375 375.683594 291.054688 375.683594 187.5 C 375.683594 83.945312 291.738281 0 188.183594 0 Z M 188.183594 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cc25455d4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.683594 0 L 374 0 L 374 375 L 0.683594 375 Z M 0.683594 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "75ed044f9b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.183594 0 C 84.628906 0 0.683594 83.945312 0.683594 187.5 C 0.683594 291.054688 84.628906 375 188.183594 375 C 291.738281 375 375.683594 291.054688 375.683594 187.5 C 375.683594 83.945312 291.738281 0 188.183594 0 Z M 188.183594 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "161ae3d9c1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 374,
    y: 0,
    height: 375
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9c8a55823f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.984375 8.300781 L 367.382812 8.300781 L 367.382812 366.699219 L 8.984375 366.699219 Z M 8.984375 8.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e217c79886"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.183594 8.300781 C 89.214844 8.300781 8.984375 88.53125 8.984375 187.5 C 8.984375 286.46875 89.214844 366.699219 188.183594 366.699219 C 287.152344 366.699219 367.382812 286.46875 367.382812 187.5 C 367.382812 88.53125 287.152344 8.300781 188.183594 8.300781 Z M 188.183594 8.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "216dc28997"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.984375 0.300781 L 359.382812 0.300781 L 359.382812 358.699219 L 0.984375 358.699219 Z M 0.984375 0.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e7e524711b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180.183594 0.300781 C 81.214844 0.300781 0.984375 80.53125 0.984375 179.5 C 0.984375 278.46875 81.214844 358.699219 180.183594 358.699219 C 279.152344 358.699219 359.382812 278.46875 359.382812 179.5 C 359.382812 80.53125 279.152344 0.300781 180.183594 0.300781 Z M 180.183594 0.300781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2ae4277956"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 360,
    y: 0,
    height: 359
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad459b731f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.324219 18.933594 L 356.457031 18.933594 L 356.457031 356.066406 L 19.324219 356.066406 Z M 19.324219 18.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c961521041"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.890625 18.933594 C 94.796875 18.933594 19.324219 94.402344 19.324219 187.5 C 19.324219 280.597656 94.796875 356.066406 187.890625 356.066406 C 280.988281 356.066406 356.457031 280.597656 356.457031 187.5 C 356.457031 94.402344 280.988281 18.933594 187.890625 18.933594 Z M 187.890625 18.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2986635f35"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.324219 0.933594 L 337.457031 0.933594 L 337.457031 338.066406 L 0.324219 338.066406 Z M 0.324219 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "493ba2983a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.890625 0.933594 C 75.796875 0.933594 0.324219 76.402344 0.324219 169.5 C 0.324219 262.597656 75.796875 338.066406 168.890625 338.066406 C 261.988281 338.066406 337.457031 262.597656 337.457031 169.5 C 337.457031 76.402344 261.988281 0.933594 168.890625 0.933594 Z M 168.890625 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f2a42db202"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 338,
    y: 0,
    height: 339
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "31ed45aef5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.234375 81.933594 L 153.777344 81.933594 L 153.777344 105.691406 L 127.234375 105.691406 Z M 127.234375 81.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d8eb53de70"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 132.484375 81.933594 L 148.4375 81.933594 C 151.335938 81.933594 153.6875 84.285156 153.6875 87.183594 L 153.6875 100.441406 C 153.6875 103.339844 151.335938 105.691406 148.4375 105.691406 L 132.484375 105.691406 C 129.585938 105.691406 127.234375 103.339844 127.234375 100.441406 L 127.234375 87.183594 C 127.234375 84.285156 129.585938 81.933594 132.484375 81.933594 Z M 132.484375 81.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "91161c107e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.234375 0.933594 L 26.777344 0.933594 L 26.777344 24.691406 L 0.234375 24.691406 Z M 0.234375 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 9.72019e+262
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.484375 0.933594 L 21.4375 0.933594 C 24.335938 0.933594 26.6875 3.285156 26.6875 6.183594 L 26.6875 19.441406 C 26.6875 22.339844 24.335938 24.691406 21.4375 24.691406 L 5.484375 24.691406 C 2.585938 24.691406 0.234375 22.339844 0.234375 19.441406 L 0.234375 6.183594 C 0.234375 3.285156 2.585938 0.933594 5.484375 0.933594 Z M 5.484375 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "38d312216e"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 27,
    y: 0,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c00c754c5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 222.691406 81.933594 L 249.230469 81.933594 L 249.230469 105.691406 L 222.691406 105.691406 Z M 222.691406 81.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9ce8226f12"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 227.941406 81.933594 L 243.890625 81.933594 C 246.792969 81.933594 249.140625 84.285156 249.140625 87.183594 L 249.140625 100.441406 C 249.140625 103.339844 246.792969 105.691406 243.890625 105.691406 L 227.941406 105.691406 C 225.039062 105.691406 222.691406 103.339844 222.691406 100.441406 L 222.691406 87.183594 C 222.691406 84.285156 225.039062 81.933594 227.941406 81.933594 Z M 227.941406 81.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "25b05d6bf9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.691406 0.933594 L 27.230469 0.933594 L 27.230469 24.691406 L 0.691406 24.691406 Z M 0.691406 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "134f16c6f9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 5.941406 0.933594 L 21.890625 0.933594 C 24.792969 0.933594 27.140625 3.285156 27.140625 6.183594 L 27.140625 19.441406 C 27.140625 22.339844 24.792969 24.691406 21.890625 24.691406 L 5.941406 24.691406 C 3.039062 24.691406 0.691406 22.339844 0.691406 19.441406 L 0.691406 6.183594 C 0.691406 3.285156 3.039062 0.933594 5.941406 0.933594 Z M 5.941406 0.933594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "526e959e2f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 28,
    y: 0,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "bf7d82b261"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 153.6875 123.605469 L 175.597656 123.605469 L 175.597656 169.652344 L 153.6875 169.652344 Z M 153.6875 123.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0cd5ad9a7f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 160.996094 169.003906 C 162.117188 169.363281 163.394531 169.601562 164.648438 169.601562 C 165.902344 169.601562 167.109375 169.398438 168.21875 169.035156 C 168.242188 169.027344 168.265625 169.027344 168.289062 169.015625 C 172.464844 167.566406 175.539062 163.746094 175.597656 158.824219 L 175.597656 123.605469 L 153.6875 123.605469 L 153.6875 158.796875 C 153.746094 163.765625 156.773438 167.589844 160.996094 169.003906 Z M 160.996094 169.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "84d780d2d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.6875 0.605469 L 22.597656 0.605469 L 22.597656 46.652344 L 0.6875 46.652344 Z M 0.6875 0.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d930ae2fe2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 7.996094 46.003906 C 9.117188 46.363281 10.394531 46.601562 11.648438 46.601562 C 12.902344 46.601562 14.109375 46.398438 15.21875 46.035156 C 15.242188 46.027344 15.265625 46.027344 15.289062 46.015625 C 19.464844 44.566406 22.539062 40.746094 22.597656 35.824219 L 22.597656 0.605469 L 0.6875 0.605469 L 0.6875 35.796875 C 0.746094 40.765625 3.773438 44.589844 7.996094 46.003906 Z M 7.996094 46.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fa8e5d6743"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a5a7d675f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169 123 L 194 123 L 194 180 L 169 180 Z M 169 123 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "81fa737523"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 169.988281 126.097656 L 179.386719 123.605469 L 193.492188 176.808594 L 184.09375 179.296875 Z M 169.988281 126.097656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3fc0d878aa"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.878906 0.601562 L 24.640625 0.601562 L 24.640625 56.519531 L 0.878906 56.519531 Z M 0.878906 0.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ece3c27bab"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.988281 3.097656 L 10.386719 0.605469 L 24.492188 53.808594 L 15.09375 56.296875 Z M 0.988281 3.097656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b207ac9d34"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 25,
    y: 0,
    height: 57
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d1218b95b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.234375 123.605469 L 165.625 123.605469 L 165.625 169.601562 L 127.234375 169.601562 Z M 127.234375 123.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "783404ac54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.234375 0.605469 L 38.625 0.605469 L 38.625 46.601562 L 0.234375 46.601562 Z M 0.234375 0.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0bdc259f50"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 39,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5383ec6d73"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 174 139 L 197 139 L 197 192 L 174 192 Z M 174 139 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "775d65eae3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 174.527344 141.949219 L 183.953125 139.558594 L 196.578125 189.347656 L 187.152344 191.734375 Z M 174.527344 141.949219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9e70006e4b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.441406 0.441406 L 22.761719 0.441406 L 22.761719 52.761719 L 0.441406 52.761719 Z M 0.441406 0.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2c6f1e08ac"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.527344 2.949219 L 9.953125 0.558594 L 22.578125 50.347656 L 13.152344 52.734375 Z M 0.527344 2.949219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "649f93c107"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ba23259eb8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 200.78125 123.605469 L 222.691406 123.605469 L 222.691406 169.652344 L 200.78125 169.652344 Z M 200.78125 123.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e3c790ca4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 208.085938 169.003906 C 209.210938 169.363281 210.488281 169.601562 211.742188 169.601562 C 212.996094 169.601562 214.199219 169.398438 215.3125 169.035156 C 215.335938 169.027344 215.359375 169.027344 215.382812 169.015625 C 219.558594 167.566406 222.632812 163.746094 222.691406 158.824219 L 222.691406 123.605469 L 200.78125 123.605469 L 200.78125 158.796875 C 200.839844 163.765625 203.867188 167.589844 208.085938 169.003906 Z M 208.085938 169.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "294dcacd02"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.78125 0.605469 L 22.691406 0.605469 L 22.691406 46.652344 L 0.78125 46.652344 Z M 0.78125 0.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7550cff586"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 8.085938 46.003906 C 9.210938 46.363281 10.488281 46.601562 11.742188 46.601562 C 12.996094 46.601562 14.199219 46.398438 15.3125 46.035156 C 15.335938 46.027344 15.359375 46.027344 15.382812 46.015625 C 19.558594 44.566406 22.632812 40.746094 22.691406 35.824219 L 22.691406 0.605469 L 0.78125 0.605469 L 0.78125 35.796875 C 0.839844 40.765625 3.867188 44.589844 8.085938 46.003906 Z M 8.085938 46.003906 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7659ca44cc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e425cb5732"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198.09375 123.601562 L 202.90625 123.601562 L 202.90625 133.324219 L 198.09375 133.324219 Z M 198.09375 123.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "551dd6d6c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.09375 0.601562 L 4.90625 0.601562 L 4.90625 10.324219 L 0.09375 10.324219 Z M 0.09375 0.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "76488a7a2d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 5,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a46dee320"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.734375 123.605469 L 250.125 123.605469 L 250.125 169.601562 L 211.734375 169.601562 Z M 211.734375 123.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0eb03e7628"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375 0.605469 L 39.125 0.605469 L 39.125 46.601562 L 0.734375 46.601562 Z M 0.734375 0.605469 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b2ea0fafa4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 40,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "58c7070b24"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183 123 L 209 123 L 209 181 L 183 181 Z M 183 123 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4051c619b9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198.804688 123.609375 L 208.167969 126.226562 L 193.015625 180.445312 L 183.652344 177.828125 Z M 198.804688 123.609375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 5206682964
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.558594 0.601562 L 25.28125 0.601562 L 25.28125 57.480469 L 0.558594 57.480469 Z M 0.558594 0.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6ea0555446"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 15.804688 0.609375 L 25.167969 3.226562 L 10.015625 57.445312 L 0.652344 54.828125 Z M 15.804688 0.609375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ca53febee6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 26,
    y: 0,
    height: 58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c024c02b48"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188 123 L 208 123 L 208 163 L 188 163 Z M 188 123 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "67261945b8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198.019531 162.257812 L 188.628906 159.742188 L 198.320312 123.582031 L 207.710938 126.097656 Z M 198.019531 162.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2f96260cb7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.601562 0.359375 L 19.800781 0.359375 L 19.800781 39.480469 L 0.601562 39.480469 Z M 0.601562 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "319e40e7c9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.019531 39.257812 L 0.628906 36.742188 L 10.320312 0.582031 L 19.710938 3.097656 Z M 10.019531 39.257812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f6fc44ca76"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "eb5db6f1c8"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170 123 L 189 123 L 189 163 L 170 163 Z M 170 123 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4085e81b9c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 188.960938 159.886719 L 179.535156 162.269531 L 170.375 125.972656 L 179.800781 123.589844 Z M 188.960938 159.886719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5c3b725204"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.359375 0.359375 L 19 0.359375 L 19 39.480469 L 0.359375 39.480469 Z M 0.359375 0.359375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "79f30c7138"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 18.960938 36.886719 L 9.535156 39.269531 L 0.375 2.972656 L 9.800781 0.589844 Z M 18.960938 36.886719 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "695e39b37f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 19,
    y: 0,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "908d32b949"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 142.371094 123.597656 L 179.808594 123.597656 L 179.808594 133.316406 L 142.371094 133.316406 Z M 142.371094 123.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8f71eb94d9"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.371094 0.597656 L 37.808594 0.597656 L 37.808594 10.316406 L 0.371094 10.316406 Z M 0.371094 0.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9b5a2b4b7f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 38,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c7e7d66cb1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 223.078125 288.632812 L 249.621094 288.632812 L 249.621094 312.390625 L 223.078125 312.390625 Z M 223.078125 288.632812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c33d78261c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 244.371094 312.390625 L 228.417969 312.390625 C 225.519531 312.390625 223.167969 310.039062 223.167969 307.140625 L 223.167969 293.882812 C 223.167969 290.984375 225.519531 288.632812 228.417969 288.632812 L 244.371094 288.632812 C 247.269531 288.632812 249.621094 290.984375 249.621094 293.882812 L 249.621094 307.140625 C 249.621094 310.039062 247.269531 312.390625 244.371094 312.390625 Z M 244.371094 312.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1b7b6dad80"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.160156 0.632812 L 26.621094 0.632812 L 26.621094 24.390625 L 0.160156 24.390625 Z M 0.160156 0.632812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "267c5ae6b3"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.371094 24.390625 L 5.417969 24.390625 C 2.519531 24.390625 0.167969 22.039062 0.167969 19.140625 L 0.167969 5.882812 C 0.167969 2.984375 2.519531 0.632812 5.417969 0.632812 L 21.371094 0.632812 C 24.269531 0.632812 26.621094 2.984375 26.621094 5.882812 L 26.621094 19.140625 C 26.621094 22.039062 24.269531 24.390625 21.371094 24.390625 Z M 21.371094 24.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "184518c147"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 27,
    y: 0,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e0ffea9a60"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.625 288.632812 L 154.167969 288.632812 L 154.167969 312.390625 L 127.625 312.390625 Z M 127.625 288.632812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7d1bfbc4b1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 148.917969 312.390625 L 132.964844 312.390625 C 130.066406 312.390625 127.714844 310.039062 127.714844 307.140625 L 127.714844 293.882812 C 127.714844 290.984375 130.066406 288.632812 132.964844 288.632812 L 148.917969 288.632812 C 151.816406 288.632812 154.167969 290.984375 154.167969 293.882812 L 154.167969 307.140625 C 154.167969 310.039062 151.816406 312.390625 148.917969 312.390625 Z M 148.917969 312.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1d74bc7e25"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.640625 0.632812 L 27.167969 0.632812 L 27.167969 24.390625 L 0.640625 24.390625 Z M 0.640625 0.632812 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f111d06005"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 21.917969 24.390625 L 5.964844 24.390625 C 3.066406 24.390625 0.714844 22.039062 0.714844 19.140625 L 0.714844 5.882812 C 0.714844 2.984375 3.066406 0.632812 5.964844 0.632812 L 21.917969 0.632812 C 24.816406 0.632812 27.167969 2.984375 27.167969 5.882812 L 27.167969 19.140625 C 27.167969 22.039062 24.816406 24.390625 21.917969 24.390625 Z M 21.917969 24.390625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "aee38872c6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 28,
    y: 0,
    height: 25
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "77c6a868f2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 201.261719 224.671875 L 223.171875 224.671875 L 223.171875 270.714844 L 201.261719 270.714844 Z M 201.261719 224.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7ce9919dce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 215.863281 225.320312 C 214.742188 224.957031 213.464844 224.722656 212.210938 224.722656 C 210.957031 224.722656 209.75 224.925781 208.640625 225.285156 C 208.617188 225.296875 208.589844 225.296875 208.566406 225.308594 C 204.394531 226.757812 201.320312 230.578125 201.261719 235.5 L 201.261719 270.714844 L 223.171875 270.714844 L 223.171875 235.527344 C 223.113281 230.554688 220.085938 226.734375 215.863281 225.320312 Z M 215.863281 225.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "fe4f90f1fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.261719 0.671875 L 22.171875 0.671875 L 22.171875 46.714844 L 0.261719 46.714844 Z M 0.261719 0.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "53980c7381"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.863281 1.320312 C 13.742188 0.957031 12.464844 0.722656 11.210938 0.722656 C 9.957031 0.722656 8.75 0.925781 7.640625 1.285156 C 7.617188 1.296875 7.589844 1.296875 7.566406 1.308594 C 3.394531 2.757812 0.320312 6.578125 0.261719 11.5 L 0.261719 46.714844 L 22.171875 46.714844 L 22.171875 11.527344 C 22.113281 6.554688 19.085938 2.734375 14.863281 1.320312 Z M 14.863281 1.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d830defee1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ad5fd65f51"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 183 215 L 207 215 L 207 271 L 183 271 Z M 183 215 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "13c2973833"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 206.863281 268.21875 L 197.46875 270.710938 L 183.363281 217.507812 L 192.761719 215.015625 Z M 206.863281 268.21875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "130752477d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.320312 0 L 24 0 L 24 55.71875 L 0.320312 55.71875 Z M 0.320312 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "da8364076e"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 23.863281 53.21875 L 14.46875 55.710938 L 0.363281 2.507812 L 9.761719 0.015625 Z M 23.863281 53.21875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ee6b7963f"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 24,
    y: 0,
    height: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3ca5e65c54"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 211.234375 224.722656 L 249.625 224.722656 L 249.625 270.714844 L 211.234375 270.714844 Z M 211.234375 224.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0bbb8d7170"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.234375 0.722656 L 38.625 0.722656 L 38.625 46.714844 L 0.234375 46.714844 Z M 0.234375 0.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1e9f115599"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 39,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2e1c1495b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 180 202 L 203 202 L 203 255 L 180 255 Z M 180 202 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a948fd0ecb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 202.324219 252.375 L 192.902344 254.765625 L 180.277344 204.980469 L 189.703125 202.589844 Z M 202.324219 252.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8f97c2842f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.199219 0.558594 L 22.519531 0.558594 L 22.519531 52.878906 L 0.199219 52.878906 Z M 0.199219 0.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "194b59b61d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 22.324219 50.375 L 12.902344 52.765625 L 0.277344 2.980469 L 9.703125 0.589844 Z M 22.324219 50.375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dd67a8725c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 53
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d8514af064"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 154.167969 224.671875 L 176.078125 224.671875 L 176.078125 270.714844 L 154.167969 270.714844 Z M 154.167969 224.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c3c5615092"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168.773438 225.320312 C 167.648438 224.957031 166.371094 224.722656 165.117188 224.722656 C 163.863281 224.722656 162.660156 224.925781 161.546875 225.285156 C 161.523438 225.296875 161.5 225.296875 161.476562 225.308594 C 157.300781 226.757812 154.226562 230.578125 154.167969 235.5 L 154.167969 270.714844 L 176.078125 270.714844 L 176.078125 235.527344 C 176.019531 230.554688 172.992188 226.734375 168.773438 225.320312 Z M 168.773438 225.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "64356579d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.167969 0.671875 L 22.078125 0.671875 L 22.078125 46.714844 L 0.167969 46.714844 Z M 0.167969 0.671875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1c09e0838f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 14.773438 1.320312 C 13.648438 0.957031 12.371094 0.722656 11.117188 0.722656 C 9.863281 0.722656 8.660156 0.925781 7.546875 1.285156 C 7.523438 1.296875 7.5 1.296875 7.476562 1.308594 C 3.300781 2.757812 0.226562 6.578125 0.167969 11.5 L 0.167969 46.714844 L 22.078125 46.714844 L 22.078125 11.527344 C 22.019531 6.554688 18.992188 2.734375 14.773438 1.320312 Z M 14.773438 1.320312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4bf6a9c188"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 23,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b5d99fbd01"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 173.1875 260.921875 L 178 260.921875 L 178 270.640625 L 173.1875 270.640625 Z M 173.1875 260.921875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "65dd5614c6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.1875 0.921875 L 5 0.921875 L 5 10.640625 L 0.1875 10.640625 Z M 0.1875 0.921875 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d1fdc7d1cb"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 5,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "5422fb1c4f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 126.734375 224.722656 L 165.125 224.722656 L 165.125 270.714844 L 126.734375 270.714844 Z M 126.734375 224.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0323bc5582"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.734375 0.722656 L 39.125 0.722656 L 39.125 46.714844 L 0.734375 46.714844 Z M 0.734375 0.722656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c38cd8132"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 40,
    y: 0,
    height: 47
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b4b452f265"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168 213 L 194 213 L 194 271 L 168 271 Z M 168 213 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: 7211205772
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 178.046875 270.710938 L 168.683594 268.09375 L 183.839844 213.875 L 193.199219 216.492188 Z M 178.046875 270.710938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4b9f351fc1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.679688 0.839844 L 25.398438 0.839844 L 25.398438 57.71875 L 0.679688 57.71875 Z M 0.679688 0.839844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e81ce098f5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.046875 57.710938 L 0.683594 55.09375 L 15.839844 0.875 L 25.199219 3.492188 Z M 10.046875 57.710938 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a41228080c"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 26,
    y: 0,
    height: 58
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b68e035b8c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 168 232 L 189 232 L 189 271 L 168 271 Z M 168 232 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "59242ed0b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 179.359375 232.066406 L 188.675781 234.835938 L 178.011719 270.71875 L 168.691406 267.949219 Z M 179.359375 232.066406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c12a384515"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.679688 0 L 20.839844 0 L 20.839844 38.960938 L 0.679688 38.960938 Z M 0.679688 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1f262969c1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.359375 0.0664062 L 20.675781 2.835938 L 10.011719 38.71875 L 0.691406 35.949219 Z M 11.359375 0.0664062 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e13c6eac19"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 21,
    y: 0,
    height: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3d773ccadd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187 232 L 207 232 L 207 271 L 187 271 Z M 187 232 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "a62bd31f3b"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 187.894531 234.425781 L 197.320312 232.046875 L 206.480469 268.34375 L 197.054688 270.722656 Z M 187.894531 234.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e70f872e47"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.878906 0 L 19.601562 0 L 19.601562 38.960938 L 0.878906 38.960938 Z M 0.878906 0 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6c7e45aee0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.894531 2.425781 L 10.320312 0.046875 L 19.480469 36.34375 L 10.054688 38.722656 Z M 0.894531 2.425781 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c588438a16"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 20,
    y: 0,
    height: 39
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a98bf387a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 197.046875 260.996094 L 234.480469 260.996094 L 234.480469 270.71875 L 197.046875 270.71875 Z M 197.046875 260.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9d3f620cfb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.046875 0.996094 L 37.480469 0.996094 L 37.480469 10.71875 L 0.046875 10.71875 Z M 0.046875 0.996094 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "e76ed43b73"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 38,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "00878cf5e6"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 170 187 L 191 187 L 191 227 L 170 227 Z M 170 187 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4ee86815cb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 181.519531 187.5 L 190.835938 190.269531 L 180.171875 226.152344 L 170.851562 223.382812 Z M 181.519531 187.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "26e1d9d3ce"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.839844 0.441406 L 21 0.441406 L 21 39.320312 L 0.839844 39.320312 Z M 0.839844 0.441406 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8a51c5589f"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 11.519531 0.5 L 20.835938 3.269531 L 10.171875 39.152344 L 0.851562 36.382812 Z M 11.519531 0.5 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2a7fc8afc0"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 21,
    y: 0,
    height: 40
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "82b1bfba42"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 127.234375 169.601562 L 250.125 169.601562 L 250.125 224.722656 L 127.234375 224.722656 Z M 127.234375 169.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c8ada37603"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.234375 0.601562 L 123.125 0.601562 L 123.125 55.722656 L 0.234375 55.722656 Z M 0.234375 0.601562 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "1003214fef"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 124,
    y: 0,
    height: 56
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "346642be28"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.9375 205.570312 L 115 205.570312 L 115 270.636719 L 80.9375 270.636719 Z M 80.9375 205.570312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9dc6a7c0a7"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.9375 0.570312 L 35 0.570312 L 35 65.636719 L 0.9375 65.636719 Z M 0.9375 0.570312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0178eecb31"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 35,
    y: 0,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "54b680e496"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95.804688 202.589844 L 125.777344 202.589844 L 125.777344 256.5625 L 95.804688 256.5625 Z M 95.804688 202.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "4a78ff15fd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 105.800781 255.558594 C 107.339844 256.140625 109.085938 256.519531 110.800781 256.519531 C 112.515625 256.519531 114.164062 256.195312 115.683594 255.613281 C 115.71875 255.59375 115.75 255.59375 115.78125 255.578125 C 121.492188 253.253906 125.695312 247.121094 125.777344 239.664062 L 125.777344 202.589844 L 95.804688 202.589844 L 95.804688 239.636719 C 95.886719 247.15625 100.027344 253.289062 105.800781 255.558594 Z M 105.800781 255.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "efba7ad4b0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 0.589844 L 30.777344 0.589844 L 30.777344 54.558594 L 0.804688 54.558594 Z M 0.804688 0.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "426774c5d0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.800781 53.558594 C 12.339844 54.140625 14.085938 54.519531 15.800781 54.519531 C 17.515625 54.519531 19.164062 54.195312 20.683594 53.613281 C 20.71875 53.59375 20.75 53.59375 20.78125 53.578125 C 26.492188 51.253906 30.695312 45.121094 30.777344 37.664062 L 30.777344 0.589844 L 0.804688 0.589844 L 0.804688 37.636719 C 0.886719 45.15625 5.027344 51.289062 10.800781 53.558594 Z M 10.800781 53.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "ed18d1a874"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 31,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9a4448eb2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.824219 205.570312 L 296.886719 205.570312 L 296.886719 270.636719 L 262.824219 270.636719 Z M 262.824219 205.570312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "af082781ba"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.824219 0.570312 L 34.886719 0.570312 L 34.886719 65.636719 L 0.824219 65.636719 Z M 0.824219 0.570312 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "cfcb6ae2f6"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 35,
    y: 0,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "521c647680"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 252.367188 202.589844 L 281.699219 202.589844 L 281.699219 256.550781 L 252.367188 256.550781 Z M 252.367188 202.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dae4366aa5"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.152344 255.558594 C 263.65625 256.140625 265.363281 256.519531 267.042969 256.519531 C 268.71875 256.519531 270.335938 256.195312 271.820312 255.613281 C 271.855469 255.59375 271.886719 255.59375 271.917969 255.578125 C 277.503906 253.253906 281.621094 247.121094 281.699219 239.664062 L 281.699219 202.589844 L 252.367188 202.589844 L 252.367188 239.636719 C 252.449219 247.15625 256.5 253.289062 262.152344 255.558594 Z M 262.152344 255.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "dcdcb20235"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.367188 0.589844 L 29.699219 0.589844 L 29.699219 54.550781 L 0.367188 54.550781 Z M 0.367188 0.589844 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "94fa0f2c53"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 10.152344 53.558594 C 11.65625 54.140625 13.363281 54.519531 15.042969 54.519531 C 16.71875 54.519531 18.335938 54.195312 19.820312 53.613281 C 19.855469 53.59375 19.886719 53.59375 19.917969 53.578125 C 25.503906 51.253906 29.621094 45.121094 29.699219 37.664062 L 29.699219 0.589844 L 0.367188 0.589844 L 0.367188 37.636719 C 0.449219 45.15625 4.5 51.289062 10.152344 53.558594 Z M 10.152344 53.558594 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b2d5b7dcc"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 30,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8d30034d2c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 262.816406 123.59375 L 296.878906 123.59375 L 296.878906 188.738281 L 262.816406 188.738281 Z M 262.816406 123.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "8147044a4d"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.816406 0.59375 L 34.878906 0.59375 L 34.878906 65.738281 L 0.816406 65.738281 Z M 0.816406 0.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "04811019a1"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 35,
    y: 0,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c2d27a7738"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 252.046875 137.640625 L 281.695312 137.640625 L 281.695312 191.730469 L 252.046875 191.730469 Z M 252.046875 137.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "29200d6e82"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 271.808594 138.699219 C 270.289062 138.117188 268.558594 137.738281 266.863281 137.738281 C 265.167969 137.738281 263.535156 138.0625 262.03125 138.644531 C 262 138.664062 261.96875 138.664062 261.933594 138.679688 C 256.285156 141.003906 252.125 147.136719 252.046875 154.59375 L 252.046875 191.730469 L 281.695312 191.730469 L 281.695312 154.621094 C 281.617188 147.101562 277.519531 140.96875 271.808594 138.699219 Z M 271.808594 138.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d314fdf2a0"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.046875 0.640625 L 29.695312 0.640625 L 29.695312 54.730469 L 0.046875 54.730469 Z M 0.046875 0.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "7c76cab764"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 19.808594 1.699219 C 18.289062 1.117188 16.558594 0.738281 14.863281 0.738281 C 13.167969 0.738281 11.535156 1.0625 10.03125 1.644531 C 10 1.664062 9.96875 1.664062 9.933594 1.679688 C 4.285156 4.003906 0.125 10.136719 0.046875 17.59375 L 0.046875 54.730469 L 29.695312 54.730469 L 29.695312 17.621094 C 29.617188 10.101562 25.519531 3.96875 19.808594 1.699219 Z M 19.808594 1.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "9bb063f9f4"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 30,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "b9047a51a2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 80.929688 123.59375 L 114.992188 123.59375 L 114.992188 188.738281 L 80.929688 188.738281 Z M 80.929688 123.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "0b24f3273a"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.929688 0.59375 L 34.992188 0.59375 L 34.992188 65.738281 L 0.929688 65.738281 Z M 0.929688 0.59375 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "f853576f6b"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 35,
    y: 0,
    height: 66
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "206586f6e2"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 95.804688 137.640625 L 125.453125 137.640625 L 125.453125 191.730469 L 95.804688 191.730469 Z M 95.804688 137.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "2b83d859bb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 115.566406 138.699219 C 114.046875 138.117188 112.316406 137.738281 110.621094 137.738281 C 108.925781 137.738281 107.292969 138.0625 105.789062 138.644531 C 105.757812 138.664062 105.726562 138.664062 105.691406 138.679688 C 100.042969 141.003906 95.882812 147.136719 95.804688 154.59375 L 95.804688 191.730469 L 125.453125 191.730469 L 125.453125 154.621094 C 125.375 147.101562 121.277344 140.96875 115.566406 138.699219 Z M 115.566406 138.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "35231715fb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.804688 0.640625 L 30.453125 0.640625 L 30.453125 54.730469 L 0.804688 54.730469 Z M 0.804688 0.640625 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "3eab64cfdb"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 20.566406 1.699219 C 19.046875 1.117188 17.316406 0.738281 15.621094 0.738281 C 13.925781 0.738281 12.292969 1.0625 10.789062 1.644531 C 10.757812 1.664062 10.726562 1.664062 10.691406 1.679688 C 5.042969 4.003906 0.882812 10.136719 0.804688 17.59375 L 0.804688 54.730469 L 30.453125 54.730469 L 30.453125 17.621094 C 30.375 10.101562 26.277344 3.96875 20.566406 1.699219 Z M 20.566406 1.699219 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "6dceca2fb3"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 31,
    y: 0,
    height: 55
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "39d8d989d1"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 198.179688 123.597656 L 235.613281 123.597656 L 235.613281 133.316406 L 198.179688 133.316406 Z M 198.179688 123.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c40afd028c"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M 0.179688 0.597656 L 37.613281 0.597656 L 37.613281 10.316406 L 0.179688 10.316406 Z M 0.179688 0.597656 ",
    clipRule: "nonzero"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c25da0faac"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 38,
    y: 0,
    height: 11
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "d3ef74513d"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0,
    width: 374,
    y: 0,
    height: 375
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 1, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d3ef74513d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d36d8e47fb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#daf87ab138)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, -0.000000000000000222, 0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#161ae3d9c1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cc25455d4f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#75ed044f9b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.683594 0 L 375.683594 0 L 375.683594 375 L 0.683594 375 Z M 0.683594 0 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9c8a55823f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e217c79886)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 8, 8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2ae4277956)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#216dc28997)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e7e524711b)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.984375 0.300781 L 359.382812 0.300781 L 359.382812 358.699219 L 0.984375 358.699219 Z M 0.984375 0.300781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad459b731f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c961521041)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 19, 18)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f2a42db202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2986635f35)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#493ba2983a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.324219 0.933594 L 337.457031 0.933594 L 337.457031 338.066406 L 0.324219 338.066406 Z M 0.324219 0.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#31ed45aef5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d8eb53de70)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 127, 81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#38d312216e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#91161c107e)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#972019e257)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.234375 0.933594 L 26.683594 0.933594 L 26.683594 24.691406 L 0.234375 24.691406 Z M 0.234375 0.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c00c754c5)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9ce8226f12)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 222, 81)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#526e959e2f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#25b05d6bf9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#134f16c6f9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.691406 0.933594 L 27.140625 0.933594 L 27.140625 24.691406 L 0.691406 24.691406 Z M 0.691406 0.933594 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#bf7d82b261)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0cd5ad9a7f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 153, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fa8e5d6743)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#84d780d2d9)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d930ae2fe2)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.6875 0.605469 L 22.597656 0.605469 L 22.597656 46.566406 L 0.6875 46.566406 Z M 0.6875 0.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a5a7d675f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#81fa737523)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 169, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b207ac9d34)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3fc0d878aa)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ece3c27bab)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.988281 3.097656 L 10.386719 0.605469 L 24.488281 53.792969 L 15.089844 56.285156 Z M 0.988281 3.097656 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1218b95b1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 127, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0bdc259f50)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#783404ac54)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.234375 0.605469 L 38.625 0.605469 L 38.625 46.644531 L 0.234375 46.644531 Z M 0.234375 0.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5383ec6d73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#775d65eae3)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 174, 139)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#649f93c107)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9e70006e4b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2c6f1e08ac)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.527344 2.949219 L 9.953125 0.558594 L 22.570312 50.328125 L 13.148438 52.71875 Z M 0.527344 2.949219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ba23259eb8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e3c790ca4f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 200, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7659ca44cc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#294dcacd02)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7550cff586)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.78125 0.605469 L 22.691406 0.605469 L 22.691406 46.566406 L 0.78125 46.566406 Z M 0.78125 0.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e425cb5732)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 198, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#76488a7a2d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#551dd6d6c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.09375 10.324219 L 0.09375 0.609375 L 4.90625 0.609375 L 4.90625 10.324219 Z M 0.09375 10.324219 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a46dee320)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 211, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b2ea0fafa4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0eb03e7628)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.734375 0.605469 L 39.125 0.605469 L 39.125 46.644531 L 0.734375 46.644531 Z M 0.734375 0.605469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#58c7070b24)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4051c619b9)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 183, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ca53febee6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5206682964)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6ea0555446)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 15.804688 0.609375 L 25.167969 3.226562 L 10.019531 57.425781 L 0.65625 54.8125 Z M 15.804688 0.609375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c024c02b48)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#67261945b8)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 188, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f6fc44ca76)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2f96260cb7)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#319e40e7c9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 10.019531 39.257812 L 0.628906 36.742188 L 10.320312 0.574219 L 19.710938 3.089844 Z M 10.019531 39.257812 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#eb5db6f1c8)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4085e81b9c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 170, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#695e39b37f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5c3b725204)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#79f30c7138)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 18.960938 36.886719 L 9.535156 39.269531 L 0.371094 2.960938 L 9.796875 0.582031 Z M 18.960938 36.886719 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#908d32b949)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 142, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9b5a2b4b7f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f71eb94d9)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.371094 10.316406 L 0.371094 0.597656 L 37.816406 0.597656 L 37.816406 10.316406 Z M 0.371094 10.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c7e7d66cb1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c33d78261c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 223, 288)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#184518c147)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1b7b6dad80)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#267c5ae6b3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 26.621094 24.390625 L 0.171875 24.390625 L 0.171875 0.632812 L 26.621094 0.632812 Z M 26.621094 24.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e0ffea9a60)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7d1bfbc4b1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 127, 288)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#aee38872c6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1d74bc7e25)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f111d06005)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 27.167969 24.390625 L 0.71875 24.390625 L 0.71875 0.632812 L 27.167969 0.632812 Z M 27.167969 24.390625 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#77c6a868f2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7ce9919dce)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 201, 224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d830defee1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#fe4f90f1fd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#53980c7381)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.171875 46.714844 L 0.261719 46.714844 L 0.261719 0.757812 L 22.171875 0.757812 Z M 22.171875 46.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ad5fd65f51)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#13c2973833)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 183, 215)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ee6b7963f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#130752477d)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#da8364076e)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 23.863281 53.21875 L 14.46875 55.710938 L 0.367188 2.519531 L 9.761719 0.03125 Z M 23.863281 53.21875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3ca5e65c54)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 211, 224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1e9f115599)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0bbb8d7170)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 38.625 46.714844 L 0.234375 46.714844 L 0.234375 0.679688 L 38.625 0.679688 Z M 38.625 46.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2e1c1495b0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a948fd0ecb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 180, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dd67a8725c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8f97c2842f)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#194b59b61d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.324219 50.375 L 12.902344 52.765625 L 0.28125 2.996094 L 9.707031 0.605469 Z M 22.324219 50.375 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d8514af064)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c3c5615092)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 154, 224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4bf6a9c188)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#64356579d0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1c09e0838f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 22.078125 46.714844 L 0.167969 46.714844 L 0.167969 0.757812 L 22.078125 0.757812 Z M 22.078125 46.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b5d99fbd01)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 173, 260)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d1fdc7d1cb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#65dd5614c6)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 5 0.921875 L 5 10.636719 L 0.1875 10.636719 L 0.1875 0.921875 Z M 5 0.921875 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#5422fb1c4f)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 126, 224)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c38cd8132)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0323bc5582)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 39.125 46.714844 L 0.734375 46.714844 L 0.734375 0.679688 L 39.125 0.679688 Z M 39.125 46.714844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b4b452f265)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7211205772)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 168, 213)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a41228080c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4b9f351fc1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e81ce098f5)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 10.046875 57.710938 L 0.683594 55.09375 L 15.832031 0.894531 L 25.195312 3.507812 Z M 10.046875 57.710938 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b68e035b8c)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#59242ed0b0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 168, 232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e13c6eac19)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c12a384515)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1f262969c1)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 11.359375 0.0664062 L 20.675781 2.835938 L 10.007812 38.730469 L 0.6875 35.957031 Z M 11.359375 0.0664062 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3d773ccadd)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a62bd31f3b)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 187, 232)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c588438a16)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e70f872e47)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6c7e45aee0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.894531 2.425781 L 10.320312 0.046875 L 19.480469 36.351562 L 10.054688 38.730469 Z M 0.894531 2.425781 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a98bf387a)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 197, 260)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#e76ed43b73)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9d3f620cfb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 37.480469 0.996094 L 37.480469 10.71875 L 0.0390625 10.71875 L 0.0390625 0.996094 Z M 37.480469 0.996094 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#00878cf5e6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4ee86815cb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 170, 187)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2a7fc8afc0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#26e1d9d3ce)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8a51c5589f)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 11.519531 0.5 L 20.835938 3.269531 L 10.167969 39.164062 L 0.847656 36.390625 Z M 11.519531 0.5 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#82b1bfba42)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 127, 169)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#1003214fef)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c8ada37603)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.234375 0.601562 L 123.183594 0.601562 L 123.183594 55.722656 L 0.234375 55.722656 Z M 0.234375 0.601562 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#346642be28)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 80, 205)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0178eecb31)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9dc6a7c0a7)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.9375 0.570312 L 35 0.570312 L 35 65.636719 L 0.9375 65.636719 Z M 0.9375 0.570312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#54b680e496)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#4a78ff15fd)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 95, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#ed18d1a874)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#efba7ad4b0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#426774c5d0)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.804688 0.589844 L 30.777344 0.589844 L 30.777344 54.5625 L 0.804688 54.5625 Z M 0.804688 0.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9a4448eb2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 262, 205)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#cfcb6ae2f6)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#af082781ba)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#000000",
    d: "M 0.824219 0.570312 L 34.886719 0.570312 L 34.886719 65.636719 L 0.824219 65.636719 Z M 0.824219 0.570312 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#521c647680)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dae4366aa5)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 252, 202)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b2d5b7dcc)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#dcdcb20235)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#94fa0f2c53)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 0.367188 0.589844 L 29.699219 0.589844 L 29.699219 54.550781 L 0.367188 54.550781 Z M 0.367188 0.589844 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8d30034d2c)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 262, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#04811019a1)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#8147044a4d)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 34.878906 65.738281 L 0.816406 65.738281 L 0.816406 0.539062 L 34.878906 0.539062 Z M 34.878906 65.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c2d27a7738)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#29200d6e82)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 252, 137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#9bb063f9f4)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#d314fdf2a0)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#7c76cab764)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 29.695312 54.730469 L 0.046875 54.730469 L 0.046875 0.757812 L 29.695312 0.757812 Z M 29.695312 54.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#b9047a51a2)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 80, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#f853576f6b)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#0b24f3273a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 34.992188 65.738281 L 0.929688 65.738281 L 0.929688 0.539062 L 34.992188 0.539062 Z M 34.992188 65.738281 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#206586f6e2)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#2b83d859bb)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 95, 137)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#6dceca2fb3)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#35231715fb)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#3eab64cfdb)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#ffffff",
    d: "M 30.453125 54.730469 L 0.804688 54.730469 L 0.804688 0.757812 L 30.453125 0.757812 Z M 30.453125 54.730469 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  }))))))), /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#39d8d989d1)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(1, 0, 0, 1, 198, 123)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c25da0faac)"
  }, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c40afd028c)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#222222",
    d: "M 0.179688 10.316406 L 0.179688 0.597656 L 37.621094 0.597656 L 37.621094 10.316406 Z M 0.179688 10.316406 ",
    fillOpacity: 1,
    fillRule: "nonzero"
  })))))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgJmLogoBlack);
export default __webpack_public_path__ + "static/media/JM-LOGO-Black.443f1da4d33a6d397b06660bc1dde04d.svg";
export { ForwardRef as ReactComponent };